import Base from './Base';
import ProductImage from './ProductImage';
import ProductLocationModel from './ProductLocation';
import moment from 'moment';
import "moment/locale/nl";

export default class ProductModel extends Base  {
	public id: number;
	public name: string;
	public description: string;
	public price: number;
	public is_editable: number;
	private _amount: number;
	public length: number;
	public width: number;
	public height: number;
	public created_at: Date;
	public categorie_id: number;
	public extra_user_id: number;
	public selling_user_id: number;
	public stateType: string;
	public nextState:object;
	public available_date:Date;
	private _product_images = [];
	public product_location: ProductLocationModel;
	constructor() {
		super(null);
		this.id = 0;
		this.name = "";
		this.description = "";
		this.price = 0;
		this.is_editable = 0;
		this.amount = 1;
		this.length = 0;
		this.width = 0;
		this.height = 0;
		this.created_at = new Date();
		this.categorie_id = 0;
		this.extra_user_id = 0;
		this.selling_user_id = 0;
		this.stateType = "";
		this.nextState = {};
		this.product_location = new ProductLocationModel();
		this.available_date = moment().format('YYYY-MM-DD'); 
		this._product_images = [];
	}

	get amount() {
		return this._amount;
	}
	set amount(val) {
		this._amount = val;
	}

	get product_images() {
		return this._product_images;
	}
	set product_images(val) {
		
		if(val && val.length > 0) {
			for(const i in val) {
				this._product_images[i] = new ProductImage(val[i]);		
			}
		}
		
	}

	protected serialize() {
		const str = JSON.stringify(this);
		return str;
	}
	
	public createNewInstance() {
		return new ProductModel();
	}


	
}